import React from "react";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import { customizedMaterialTheme } from "./shared/style/theme";
import { SnackbarProvider } from "notistack";
import { LocalizationProvider } from "@mui/x-date-pickers-pro";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { RouterProvider } from "react-router";
import { initTranslation } from "./i18n/i18n";
import { router } from "./router";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import HttpError from "./shared/networking/http_error";
import { CommonApiResultError } from "shared/networking/common_api_result";
import ErrorListener from "shared/components/api_error_listener/error_listener.component";
import { registerKnittingProgramLibraryBreadcrumbs } from "assets/knittingProgramLibrary/components/registerKnittingProgramBreadcrumbs";

const HTTP_STATUS_TO_NOT_RETRY = ["400", "401", "403", "404"];

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 0,
      retry: (failureCount, error) => {
        if (
          error instanceof HttpError &&
          HTTP_STATUS_TO_NOT_RETRY.includes(error.code)
        ) {
          return false;
        }
        if (
          error instanceof CommonApiResultError &&
          HTTP_STATUS_TO_NOT_RETRY.includes(error.errorCode.toString())
        ) {
          return false;
        }
        return failureCount < 3;
      },
      refetchOnWindowFocus: false,
    },
  },
});

// Register module-specific breadcrumbs
registerKnittingProgramLibraryBreadcrumbs();

const App = () => {
  initTranslation();
  return (
    <QueryClientProvider client={queryClient}>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <ThemeProvider theme={customizedMaterialTheme}>
          <CssBaseline />
          <SnackbarProvider
            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
          >
            <RouterProvider router={router} />
          </SnackbarProvider>
        </ThemeProvider>
      </LocalizationProvider>
      <ErrorListener />
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  );
};

export default App;
